<template>
<div class="checkout-page">
  <div class="payment-information-column">
    <br>
    <div id="klarna_container" class="klarna_container" />
  </div>

  <div class="summary-wrapper">
    <checkout-summary
      :disabled="isPending || !isLoaded"
      @purchase="purchase"
      />

    <br>
    <div class="loader-wrapper">
      <line-loader v-if="isPending"/>

      <i v-if="purchaseError">
        {{ __('Something went wrong! Please check so all fields are correctly filled in.') }}
      </i>
    </div>
  </div>
</div>
</template>
<script>
import CheckoutSummary from 'components/orderPage/CheckoutSummary.vue'
import LineLoader from 'components/elements/LineLoader.vue'

import klarna from 'services/klarna.js'
import emailApi from 'services/emailApi.js'
import dataLog from 'services/dataLog.js'
import analytics from 'services/analytics.js'

import logScope from 'log-scope'
const log = logScope('KlarnaPayments')

export default {
  components: { CheckoutSummary, LineLoader },
  data () {
    return {
      isPending: false,
      isLoaded: false,
      purchaseError: false
    }
  },
  async mounted () {
    this.isLoaded = false
    const orderLines = this.$store.getters.klarnaOrderLines

    try {
      klarna.updateOrder(orderLines)
      await klarna.init()

      await klarna.showPaymentOptions()
      log.success('Payment visible')
      this.isLoaded = true
    } catch (err) {
      log.error('Could not show payment options', err)
      this.purchaseError = true
      this.$store.commit('showKlarnaPaymentOption', false)
    }
  },
  methods: {
    async purchase () {
      this.isPending = true
      this.isLoaded = false
      this.purchaseError = false

      const orderLines = this.$store.getters.klarnaOrderLines
      const couponCode = this.$store.getters.couponCode
      const partnerCode = this.$store.getters.partnerCode
      const abTestCode = this.$store.getters.abTestCode || ''

      log.debug('About to submit purchase', orderLines, couponCode, partnerCode)

      try {
        klarna.updateOrder(orderLines)

        const order = await klarna.pay({ couponCode, partnerCode, abTestCode })
        const email = order.billing_address.email
        log.success('Purchase completed')

        dataLog.latest({
          status: 'success',
          message: 'New purchase!'
        })

        analytics.purchase()

        await emailApi.sendKlarnaOrderVerification({
          partnerCode,
          email
        })

        // Continue to next page
        this.nextPage()
      } catch (err) {
        log.error('Could not place klarna order', err)
        this.purchaseError = true
      }

      this.isPending = false
      this.isLoaded = true
    },
    nextPage () {
      this.$router.push({ name: 'HomePage' })
      this.$router.push({ name: 'OrderPage' })
      this.$router.push({ name: 'HomePage' })
      this.$router.push({ name: 'PostPurchasePage' })
    }
  }
}
</script>
<style lang="less" scoped>
  @import '../../style/variables.less';

  .klarna_container {
    min-height: 100px;
    width: 100%;
  }

  /* Shared child classes */
  .checkout-page {
    background-color: #ffffff;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    height: auto;
    width: 100%;
    margin-bottom: 100px;

    @media (max-width: 800px) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }
  }

  .payment-information-column {
    width: 100%;
    max-width: 500px;
    box-sizing: border-box;
    padding-right: 20px;

    i {
      color: @warning-dark;
      font-size: 14px;
    }

    @media (max-width: 800px) {
      padding-right: 0px;
      max-width: 400px;
    }
  }

  .summary-wrapper {
    width: 100%;
    max-width: 300px;
    box-sizing: border-box;
    padding-left: 20px;

    @media (max-width: 800px) {
      padding-left: 0px;
      max-width: 400px;
      margin: 50px 0px;
    }

    .loader-wrapper {
      height: 20px;
      width: 100%;

      i {
        color: @warning-dark;
        font-size: 14px;
      }
    }
  }
</style>
